export type InvitePillColor = {
    fill: string;
    hover: string;
    muted: string;
};

export const GENERAL_INVITE_TAGS = [
    {
        id: 'waitlist',
        label: 'Waitlist',
        // Warm gold: a seat on the list — inviting, earned.
        color: { fill: '#c9952a', hover: '#b07f1c', muted: '#e0b44a' },
    },
    {
        id: 'puppy-application',
        label: 'Application received',
        // Sage: paperwork finished, calm progress.
        color: { fill: '#4f7c74', hover: '#40655e', muted: '#6f9a93' },
    },
    {
        id: 'social-media',
        label: 'Social media',
        // Dusty rose: warm, conversational inbound.
        color: { fill: '#a56b78', hover: '#8d5964', muted: '#c08d97' },
    },
    {
        id: 'interview-pending',
        label: 'Interview pending',
        // Amber: needs a call.
        color: { fill: '#c48a3a', hover: '#a8742f', muted: '#d4a45e' },
    },
    {
        id: 'interview-completed',
        label: 'Interview completed',
        // Slate: conversation closed, filed. Not another green.
        color: { fill: '#4b5c72', hover: '#3d4c5f', muted: '#7a8ba0' },
    },
    {
        id: 'follow-up',
        label: 'Follow up',
        // Orchid: unused against gold, sage, rose, amber, slate, and stone.
        color: { fill: '#7e4d9a', hover: '#683f80', muted: '#b07dcc' },
    },
    {
        id: 'no-response',
        label: 'No response',
        // Cool stone: went quiet, not an alarm.
        color: { fill: '#6d6a75', hover: '#54515c', muted: '#9a97a1' },
    },
] as const;

export type GeneralInviteTag = (typeof GENERAL_INVITE_TAGS)[number]['id'];

export const WAITLIST_TAG = GENERAL_INVITE_TAGS.find((tag) => tag.id === 'waitlist')!;

export const DEPOSIT_STATUSES = [
    {
        id: 'pending',
        label: 'Deposit pending',
        // Same amber as interview pending: money still owed.
        color: { fill: '#c48a3a', hover: '#a8742f', muted: '#d4a45e' },
    },
    {
        id: 'paid',
        label: 'Deposit paid',
        // Site blue: confirmed, official.
        color: { fill: '#1976d2', hover: '#1565c0', muted: '#4d9ae0' },
    },
] as const;

export type DepositStatus = '' | (typeof DEPOSIT_STATUSES)[number]['id'];

export const isGeneralInviteTag = (value: string): value is GeneralInviteTag =>
    GENERAL_INVITE_TAGS.some((tag) => tag.id === value);

export const selectedInviteTag = (
    tags: GeneralInviteTag[] | null | undefined
): GeneralInviteTag | null => {
    if (!tags || !tags.length) {
        return null;
    }

    for (let index = 0; index < GENERAL_INVITE_TAGS.length; index += 1) {
        const tag = GENERAL_INVITE_TAGS[index];
        if (tags.indexOf(tag.id) !== -1) {
            return tag.id;
        }
    }
    return null;
};
